
import {Component, Vue} from "vue-property-decorator";
import Base from "@/views/审核管理/view/component/homestayBase.vue";
import Address from "@/views/审核管理/view/component/address.vue";
import Contacts from "@/views/审核管理/view/component/contacts.vue";
import nyNetwork from "@/api/nyBaseNetwork";
import DZServiceHomestay from "@/views/审核管理/service/DZServiceHomestay";

@Component({
    components: {Base,Address,Contacts}
})
export default class Index extends Vue {

    created(){
        this.homestay_id = this.$route.query.id as string;
        this.net_list_dic_all()
    }

    mounted(){
        this.action_get_info()
    }

    dic = [];

    homestay_id = "";

    serve = new DZServiceHomestay();

    net_list_dic_all(){
        nyNetwork.get("字典列表全部",{}, data => {
            this.dic = data
        })
    }

    action_get_info(){
        this.serve.net_homestay_info(this.homestay_id)
    }

    action_update_base(m){
        this.serve.net_edit_homestay_base(m)
    }

    action_update_address(m){
        this.serve.net_edit_address(m)
    }

    action_update_contact(m){
        this.serve.net_edit_contact(m)
    }
}